import React, { ReactNode } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline"; // Import CssBaseline

const theme = createTheme({
  palette: {
    primary: {
      main: "#2B8EF8", // Blue from the logo
      light: "#5AB1FF",
      dark: "#1565c0",
    },
    secondary: {
      main: "#9C45F3", // Purple from the logo
      light: "#BB74FF",
      dark: "#7B35C2",
    },
    error: {
      main: "#d32f2f", // A deep red for error
    },
    background: {
      default: "#FAFAFA", // Light background for better contrast
      paper: "#FFFFFF",
    },
  },
  typography: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    h1: {
      fontWeight: 600,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          margin: 0,
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
          backgroundColor: "#FAFAFA",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 24,
          textTransform: "none",
          fontWeight: 600,
        },
        containedPrimary: {
          background: "linear-gradient(90deg, #2B8EF8 0%, #9C45F3 100%)",
          '&:hover': {
            background: "linear-gradient(90deg, #1A7DE7 0%, #8B34E2 100%)",
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          flex: 1,
          overflow: "auto",
        },
        paper: {
          backgroundColor: "#FFFFFF",
          borderRight: "1px solid rgba(0, 0, 0, 0.08)",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: "linear-gradient(90deg, #2B8EF8 0%, #9C45F3 100%)",
          position: "fixed",
          zIndex: 1201,
          height: 64,
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          minHeight: 64,
        },
      },
    },
  },
});

// Define prop types for children
interface ThemeWrapperProps {
  children: ReactNode;
}

const ThemeWrapper: React.FC<ThemeWrapperProps> = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default ThemeWrapper;
